import { Table } from '@tanstack/react-table';
import { useTranslation } from 'react-i18next';
import { CloseIcon } from '../../../icons';
import { IconButton } from '@mui/material';
interface DataTableResultsProps<TData> {
  table: Table<TData>;
  canDeselect?: boolean;
  customHeadline?: string;
}

export function DataTableResults<TData>({
  table,
  canDeselect,
  customHeadline
}: Readonly<DataTableResultsProps<TData>>) {
  const { t } = useTranslation();
  const selectedCount = table.getFilteredSelectedRowModel().rows.length;
  const totalCount = table.getFilteredRowModel().rows.length;
  const isSelected = selectedCount > 0;

  const noSelectedString = `${totalCount} ${
    customHeadline
      ? t(`${customHeadline}`, { count: totalCount })
      : t('template:ENTRIES', {
          count: totalCount
        })
  }`;
  const selectedString = `${t('template:N_OF_N', {
    num: selectedCount,
    total: totalCount
  })} ${t('template:ENTRIES', {
    count: totalCount
  })}${totalCount != 1 ? t('template:n') : ''} ${t('common:SELECTED')}`;

  return (
    <div className="flex-1 font-medium text-base text-muted-foreground whitespace-nowrap flex items-center gap-2">
      {isSelected ? selectedString : noSelectedString}
      {canDeselect && isSelected && (
        <IconButton
          sx={{ padding: 0 }}
          onClick={() => table.resetRowSelection()}
          aria-label="Deselect all"
        >
          <CloseIcon />
        </IconButton>
      )}
    </div>
  );
}
